import {isString} from 'lodash'

export function getRandomId(prefix = '') {
    return `${prefix}_${(
        performance.now().toString(36) +
        Math.random().toString(36).substring(2, 9)
    ).replace(/\./g, '')}`
}

export function forceToNumber(v) {
    return v ? (Number(v.toString().replace(/[^0-9.-]+/g, '')) || 0) : 0
}

/**
 * Usually used with price comparison
 * => default dispersion two cents (0.02)
 * (0.0001 - adjustment to overlap JS numbers diff ending like .00000000001)
 */
export function equalWithDispersion(x = 0, y = 0, dispersion = 0.0201) {
    return Math.abs(x - y) <= dispersion
}

export function chunkString(str, size) {
    return str.match(new RegExp('.{1,' + size + '}', 'g'))
}

export function countDecimals(number) {
    if (Math.floor(number.valueOf()) === number.valueOf()) {
        return 0
    }
    const parts = number.toString().split('.')
    return parts.length > 1 ? parts[1].length : 0
}

export const getFromBetween = {
    results: [],
    string: '',
    getFromBetween: function(sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false
        const SP = this.string.indexOf(sub1) + sub1.length
        const string1 = this.string.substr(0, SP)
        const string2 = this.string.substr(SP)
        const TP = string1.length + string2.indexOf(sub2)
        return this.string.substring(SP, TP)
    },
    removeFromBetween: function(sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false
        const removal = sub1 + this.getFromBetween(sub1, sub2) + sub2
        this.string = this.string.replace(removal, '')
    },
    getAllResults: function(sub1, sub2) {
        // first check to see if we do have both substrings
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return

        // find one result
        const result = this.getFromBetween(sub1, sub2)
        // push it to the results array
        // @ts-ignore
        this.results.push(result)
        // remove the most recently found one from the string
        this.removeFromBetween(sub1, sub2)

        // if there's more substrings
        if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1, sub2)
        }
    },
    get: function(string, sub1, sub2) {
        this.results = []
        this.string = string
        this.getAllResults(sub1, sub2)
        return this.results
    }
}

export function splitMulti(str, separators, includeSeparator) {
    if (!str || !isString(str)) {
        return []
    }
    const tempChar = '@@@'
    for (let i = 0; i < separators.length; i++) {
        if (includeSeparator) {
            const regex = new RegExp('(' + quote(separators[i]) + ')', 'g')
            str = str.split(regex).join(tempChar)
        } else {
            str = str.split(separators[i]).join(tempChar)
        }
    }
    return str.split(tempChar)
}

const quote = function(str) {
    return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
}

export const flattenObject = (o) => {
    if (!o) {
        return {}
    }
    const toReturn = {}

    for (let i in o) {
        if (!o.hasOwnProperty(i)) continue

        if ((typeof o[i]) === 'object' && o[i] !== null) {
            const flatObject = flattenObject(o[i])
            for (const x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue
                // @ts-ignore
                toReturn[i + '.' + x] = flatObject[x]
            }
        } else {
            // @ts-ignore
            toReturn[i] = o[i]
        }
    }
    return toReturn
}

export const getUrlSearchParameterByName = (url = '', name = '') => {
    const urlObj = new URL(url)
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(urlObj.search)
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}
